import { useRef } from "react";
import { Menu } from "primereact/menu";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { useGlobalContext } from "./Config";
import { useOffline } from "./offline/OfflineContext";

const AppTopbar = (props) => {
  const navigate = useNavigate();
  const menuMantenedores = useRef(null);
  const menuReportes = useRef(null);
  const menuPerfil = useRef(null);
  const reportesTargetRef = useRef(null);
  const mantenedoresTargetRef = useRef(null);
  const perfilTargetRef = useRef(null);
  const hoverReportesTimeout = useRef(null);
  const hoverMantenedoresTimeout = useRef(null);
  const hoverPerfilTimeout = useRef(null);
  const { styleProperties, isDinar, isSack } = useGlobalContext();
  const { offlineMode, setOfflineMode } = useOffline();

  const hideMenu = (menuRef, targetRef) => {
    if (menuRef?.current && targetRef?.current) {
      menuRef.current.hide({ currentTarget: targetRef.current });
    }
  };

  const closeAllMenus = () => {
    hideMenu(menuReportes, reportesTargetRef);
    hideMenu(menuMantenedores, mantenedoresTargetRef);
    hideMenu(menuPerfil, perfilTargetRef);
  };

  const openOnlyMenu = (menuRef, targetRef, currentTarget) => {
    targetRef.current = currentTarget;
    closeAllMenus();
    menuRef.current?.show({ currentTarget: targetRef.current });
  };

  const scheduleHideMenu = (menuRef, targetRef, timeoutRef, delay = 300) => {
    timeoutRef.current = setTimeout(() => {
      const targetEl = targetRef.current;
      const menuEl = menuRef.current?.getElement?.();
      const isTargetHovered = !!targetEl?.matches?.(":hover");
      const isMenuHovered = !!menuEl?.matches?.(":hover");

      if (!isTargetHovered && !isMenuHovered) {
        hideMenu(menuRef, targetRef);
      }
    }, delay);
  };

  const itemsMantenedores = offlineMode
    ? [{ label: "Modo Offline", command: () => navigate("/offline") }]
    : [
        ...(isSack
          ? [
              {
                label: "Competencias",
                command: () => navigate("/competencias"),
                disabled: true,
              },
              {
                label: "Causas de Pérdida",
                command: () => navigate("/causas-perdida"),
                disabled: true,
              },
              {
                label: "Cierres de Cotización",
                command: () => navigate("/cierres-cotizacion"),
                disabled: true,
              },
              {
                label: "Estados",
                command: () => navigate("/estados"),
                disabled: true,
              },
              { label: "Usuarios", command: () => navigate("/usuarios") },
              { label: "Modo Offline", command: () => navigate("/offline") },
              {
                label: "Constantes P.E.",
                command: () => navigate("/constantes-pe"),
                disabled: true,
              },
              {
                label: "Materia Prima P.E.",
                command: () => navigate("/materia-prima-pe"),
                disabled: true,
              },
              {
                label: "Servicio de Armado P.E.",
                command: () => navigate("/servicio-armado-pe"),
                disabled: true,
              },
              {
                label: "Servicio de Corte P.E.",
                command: () => navigate("/servicio-corte-pe"),
                disabled: true,
              },
              {
                label: "Servicio de Perforacion P.E.",
                command: () => navigate("/servicio-perforacion-pe"),
                disabled: true,
              },
            ]
          : []),
        ...(isDinar
          ? [
              { label: "Usuarios", command: () => navigate("/usuarios") },
              { label: "Sincronizar", command: () => navigate("/sincronizar") },
              { label: "Modo Offline", command: () => navigate("/offline") },
            ]
          : []),
      ];

  const itemsReportes = offlineMode
    ? []
    : [
        ...(isSack
          ? [
              { label: "Tablero", command: () => navigate("/tablero") },
              {
                label: "Lista de Cotizaciones",
                command: () => navigate("/reporte-cotizacion"),
              },
              {
                label: "Estado de Cotizaciones",
                command: () => navigate("/estado-cotizaciones"),
                disabled: true,
              },
              {
                label: "Propuesta / Compra",
                command: () => navigate("/propuesta-compra"),
                disabled: true,
              },
              {
                label: "Estado Financiero",
                command: () => navigate("/estado-financiero"),
                disabled: true,
              },
              {
                label: "Coberturas",
                command: () => navigate("/coberturas"),
                disabled: true,
              },
              {
                label: "Reporte Precios Pendientes",
                command: () => navigate("/reporte-precios-pendientes"),
                disabled: true,
              },
            ]
          : []),
        ...(isDinar
          ? [
              {
                label: "Lista Cotizaciones",
                command: () => navigate("/reporte-cotizacion"),
              },
              {
                label: "Lista Nota de Venta",
                command: () => navigate("/reporte-nota-venta"),
              },
              {
                label: "Lista Cotizaciones Bloqueadas",
                command: () => navigate("/reporte-cotizacion-bloqueada"),
              },
              {
                label: "Tiempo respuesta",
                command: () => navigate("/reporte-tiempo-respuesta"),
              },
              {
                label: "Detalles no confirmados",
                command: () => navigate("/reporte-no-confirmados"),
              },
            ]
          : []),
      ];

  const itemsPerfil = [
    { label: "Administrar", command: () => navigate("/perfil") },
  ];

  return (
    <div className="layout-topbar shadow-4">
      <div className="layout-topbar-left p-0">
        <button
          type="button"
          style={{ cursor: "pointer" }}
          className=" p-link p-0"
          onClick={() => navigate("/tablero")}
        >
          <img
            src={styleProperties.logo}
            alt=""
            style={{
              height: "58px",
              objectFit: "contain",
              width: "10rem",
              backgroundColor: "white",
            }}
          />
        </button>

        <button
          type="button"
          className="layout-menu-button shadow-6 p-link lg:hidden"
          onClick={props.onMenuButtonClick}
        >
          <i className="pi pi-chevron-right"></i>
        </button>
      </div>

      <div className="layout-topbar-right p-0">
        <div className="flex align-items-center justify-content-between w-full">
          <div className="flex align-items-center">
            {isDinar && (
              <Button
                type="button"
                className="p-button-text text-white font-medium"
                onClick={() => navigate("/nota-venta")}
                label="Ingresar Nota De Venta"
                icon="pi pi-file"
              />
            )}

            {isSack && (
              <>
                <Button
                  type="button"
                  className="p-button-text text-white font-medium"
                  onClick={() => navigate("/boleta")}
                  label="Cotización Boleta"
                  icon="pi pi-file"
                />

                <Button
                  type="button"
                  className="p-button-text text-white font-medium"
                  onClick={() => navigate("/factura")}
                  label="Cotización Factura"
                  icon="pi pi-file-o"
                />

                {!offlineMode && (
                  <Button
                    type="button"
                    className="p-button-text text-white font-medium"
                    onClick={() => navigate("/reporte-cotizacion")}
                    label="Cotizaciones"
                    icon="pi pi-folder"
                  />
                )}
              </>
            )}

            {!offlineMode && (
              <>
                <Menu
                  model={itemsReportes}
                  popup
                  ref={menuReportes}
                  id="popup_menu_reportes"
                />

                <Button
                  type="button"
                  className="p-button-text text-white font-medium"
                  onClick={(event) => menuReportes.current.toggle(event)}
                  onMouseEnter={(event) => {
                    if (hoverReportesTimeout.current) {
                      clearTimeout(hoverReportesTimeout.current);
                      hoverReportesTimeout.current = null;
                    }
                    openOnlyMenu(
                      menuReportes,
                      reportesTargetRef,
                      event.currentTarget,
                    );
                  }}
                  onMouseLeave={() => {
                    scheduleHideMenu(
                      menuReportes,
                      reportesTargetRef,
                      hoverReportesTimeout,
                    );
                  }}
                  aria-controls="popup_menu_reportes"
                  aria-haspopup
                  label="Reportes"
                  icon="pi pi-chart-bar"
                />
              </>
            )}

            <Menu
              model={itemsMantenedores}
              popup
              ref={menuMantenedores}
              id="popup_menu_mantenedores"
            />

            <Button
              type="button"
              className="p-button-text text-white font-medium"
              onClick={(event) => menuMantenedores.current.toggle(event)}
              onMouseEnter={(event) => {
                if (hoverMantenedoresTimeout.current) {
                  clearTimeout(hoverMantenedoresTimeout.current);
                  hoverMantenedoresTimeout.current = null;
                }
                openOnlyMenu(
                  menuMantenedores,
                  mantenedoresTargetRef,
                  event.currentTarget,
                );
              }}
              onMouseLeave={() => {
                scheduleHideMenu(
                  menuMantenedores,
                  mantenedoresTargetRef,
                  hoverMantenedoresTimeout,
                );
              }}
              aria-controls="popup_menu_mantenedores"
              aria-haspopup
              label={offlineMode ? "Offline" : "Mantenedores"}
              icon={offlineMode ? "pi pi-database" : "pi pi-cog"}
            />

            {isDinar && (
              <>
                <Menu
                  model={itemsPerfil}
                  popup
                  ref={menuPerfil}
                  id="popup_menu_perfil"
                />

                <Button
                  type="button"
                  className="p-button-text text-white font-medium"
                  label="Perfil"
                  icon="pi pi-user"
                  onClick={(event) => menuPerfil.current.toggle(event)}
                  onMouseEnter={(event) => {
                    if (hoverPerfilTimeout.current) {
                      clearTimeout(hoverPerfilTimeout.current);
                      hoverPerfilTimeout.current = null;
                    }
                    openOnlyMenu(
                      menuPerfil,
                      perfilTargetRef,
                      event.currentTarget,
                    );
                  }}
                  onMouseLeave={() => {
                    scheduleHideMenu(
                      menuPerfil,
                      perfilTargetRef,
                      hoverPerfilTimeout,
                    );
                  }}
                  aria-controls="popup_menu_perfil"
                  aria-haspopup
                />

                <Button
                  type="button"
                  className="p-button-text text-white"
                  onClick={() => {
                    sessionStorage.clear();
                    navigate("/");
                  }}
                  label="Salir"
                  icon="pi pi-power-off"
                />
              </>
            )}
          </div>

          <div
            className="flex align-items-center mr-4"
            style={{ gap: ".5rem" }}
          >
            <span
              style={{
                fontWeight: 600,
                color: offlineMode ? "#ffb300" : "white",
              }}
            >
              {offlineMode ? "OFFLINE" : "ONLINE"}
            </span>

            <InputSwitch
              checked={offlineMode}
              onChange={(e) => setOfflineMode(e.value)}
            />
          </div>

          <div className="flex align-items-center gap-1 mr-3">
            <span className="">
              {sessionStorage.getItem("user")} -{" "}
              {{
                ROLE_NONE: "SIN PERFIL",
                ROLE_ADMINISTRADOR: "ADMINISTRADOR", // vende + mantenedores,
                ROLE_LIDER: "LIDER", // vende
                ROLE_COORDINADOR: "COORDINADOR", //vende
                ROLE_VENDEDOR: "VENDEDOR", //UNAUTHORIZED // vende
                ROLE_COORDINADOR_B2B: "COORDINADOR B2B", //UNAUTHORIZED // vende
                ROLE_VENDEDOR_PPEE: "VENDEDOR PRODUCTOS ESPECIALES", //UNAUTHORIZED // vende y ppee unicamente
                ROLE_SUCURSAL: "SUCURSAL", // vende
                ROLE_TELEVENTAS: "CONTACT CENTER", // vende
                ROLE_CLIENTE: "CLIENTE", // eliminar
              }[sessionStorage.getItem("authority")] ||
                sessionStorage.getItem("authority")}
            </span>

            <span className="">| Ver.1.12.0 </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppTopbar;
